export default "__VITE_ASSET__CqcvG7to__"